import { render } from "./Mainradio.vue?vue&type=template&id=700aac93&scoped=true"
import script from "./Mainradio.vue?vue&type=script&lang=js"
export * from "./Mainradio.vue?vue&type=script&lang=js"

import "./Mainradio.vue?vue&type=style&index=0&id=700aac93&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700aac93"]])

export default __exports__